import $ from "jquery";
import {isMobile} from "Core/screenSizes";

export const navLineOpener = () => {
    if (!isMobile()) {
        return;
    }

    $(".nav-line-more-button").click(function (e) {
        e.preventDefault();

        $('body').toggleClass('nav-line-active');
    });

    $('.nav-line-mobile').css('top', 0);
};
